var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRightArrow = function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.63 5.107H1.562c-1.05 0-1.05 1.785 0 1.785H11.63L8.866 9.96c-.735.815.385 2.057 1.154 1.242l4.094-4.58a.935.935 0 0 0 0-1.242L10.02.799c-.77-.815-1.889.427-1.154 1.28l2.764 3.028Z",
    fill: "#141975"
  })));
};
export default SvgRightArrow;